export default __webpack_public_path__ + "static/media/icon-arrow-page-right.ed878965.svg";